import React, { useState } from 'react';
import style from '../group.module.scss';
import { Input } from '../../../../../components';
import { EditIcon } from '../../../../../icons';
import { validate } from '../../../../../utils/validation';
import { usePermissions } from '../../../../../hooks';

type Props = {
	isEditing: boolean;
	groupName: string;
	onEnter: (groupName: string) => void;
	closeInput: () => void;
	showInput: () => void;
};

export function Title(props: Props) {
	const { isEditing, groupName, onEnter, closeInput, showInput } = props;
	const canEdit = usePermissions('nlu.Edit')
	const [error, setError] = useState('');

	function validateUtterance(utterance: string) {
		setError('');
		const result = validate('title', utterance, [
			{
				message: "Title value can't be empty",
				fn: (value: string) => value.trim().length <= 0,
			},
		]);
		if (result.title) {
			setError(result.title);
		}
		return result.title;
	}

	function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
		const value = e.currentTarget.value;
		validateUtterance(value);
	}

	function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
		const value = e.currentTarget.value;
		if (e.keyCode === 13 && !error) {
			const error = validateUtterance(value);
			if (!error) {
				onEnter(e.currentTarget.value);
			}
		}
	}

	return (
		<div className={style.title}>
			{isEditing ? (
				<Input
					error={error}
					onChange={handleChange}
					onKeyDown={handleKeyDown}
					autoFocus
					defaultValue={groupName}
					close={closeInput}
				/>
			) : (
				<>
					<p>{groupName}</p>
					{canEdit && (
						<button onClick={showInput}>
							<EditIcon width="14" height="14" stroke="#0466C8" />
						</button>
					)}
				</>
			)}
		</div>
	);
}
